module.exports = __webpack_public_path__ + "img/Quiet-Cove-024.2ea36400.jpg";